// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* COLORS */
/* MEASUREMENTS */
.overlayContainer[data-v-b0d9497c] {
  position: relative;
}
.overlayContainer .overlay[data-v-b0d9497c] {
  display: flex;
  align-items: center;
  margin: auto;
  z-index: 3;
}
.overlayContainer .overlay .overlayCenter[data-v-b0d9497c] {
  text-align: center;
  z-index: 5;
  opacity: 1;
  box-shadow: 0 0 50px 50px #ffffff;
  background: #ffffff;
  padding: 15px;
  max-width: 450px;
}
.adminDiffControlContainer[data-v-b0d9497c] {
  padding: 10px 15px;
}
.adminDiffControlContainer .changedKey[data-v-b0d9497c],
.adminDiffControlContainer .deletedKey[data-v-b0d9497c],
.adminDiffControlContainer .addedKey[data-v-b0d9497c] {
  color: white;
}
.adminDiffControlContainer .changedKey[data-v-b0d9497c] {
  background: #2568db;
}
.adminDiffControlContainer .deletedKey[data-v-b0d9497c] {
  background: #d70015;
}
.adminDiffControlContainer .addedKey[data-v-b0d9497c] {
  background: #208337;
}
.changed[data-v-b0d9497c],
.deleted[data-v-b0d9497c],
.new[data-v-b0d9497c] {
  border-style: dashed;
  border-width: 2px;
}
.changed[data-v-b0d9497c] {
  border-color: #2568db !important;
}
.deleted[data-v-b0d9497c] {
  border-color: #d70015 !important;
}
.new[data-v-b0d9497c] {
  border-color: #208337 !important;
}
.df-workflow-title[data-v-b0d9497c] {
  display: block;
  color: #687078;
  font-size: 0.6em;
}
.df-form-title[data-v-b0d9497c] {
  font-size: 26px;
}
.df-segment-title[data-v-b0d9497c] {
  display: block;
  margin-bottom: 7.5px;
}
.save-all-container[data-v-b0d9497c] {
  position: sticky;
  top: -10px;
  margin-top: -40px;
  margin-left: auto;
  padding: 0 15px;
  z-index: 10001;
}
.btn-outline-secondary[data-v-b0d9497c]:not(:hover):not(:focus) {
  background-color: #ffffff;
}
.alert-issues[data-v-b0d9497c] {
  background: #ffc107;
  color: #000;
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./../PageSide.3.vue","webpack://./public/pages/PageSide.3.vue"],"names":[],"mappings":"AAAA,WAAW;AACX,iBAAiB;ACCjB;EACI,kBAAA;ADCJ;ACFA;EAGQ,aAAA;EACA,mBAAA;EACA,YAAA;EACA,UAAA;ADER;ACRA;EAQY,kBAAA;EACA,UAAA;EACA,UAAA;EACA,iCAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;ADGZ;ACIA;EACI,kBAAA;ADFJ;ACCA;;;EAKQ,YAAA;ADDR;ACJA;EAQQ,mBAAA;ADDR;ACPA;EAWQ,mBAAA;ADDR;ACVA;EAcQ,mBAAA;ADDR;ACKA;;;EAGI,oBAAA;EACA,iBAAA;ADHJ;ACKA;EACI,gCAAA;ADHJ;ACKA;EACI,gCAAA;ADHJ;ACKA;EACI,gCAAA;ADHJ;ACKA;EACI,cAAA;EACA,cAAA;EACA,gBAAA;ADHJ;ACKA;EACI,eAAA;ADHJ;ACKA;EACI,cAAA;EACA,oBAAA;ADHJ;ACKA;EACI,gBAAA;EACA,UAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;ADHJ;ACKA;EACI,yBAAA;ADHJ;ACKA;EACI,mBAAA;EACA,WAAA;EACA,gBAAA;ADHJ","sourcesContent":["/* COLORS */\n/* MEASUREMENTS */\n.overlayContainer {\n  position: relative;\n}\n.overlayContainer .overlay {\n  display: flex;\n  align-items: center;\n  margin: auto;\n  z-index: 3;\n}\n.overlayContainer .overlay .overlayCenter {\n  text-align: center;\n  z-index: 5;\n  opacity: 1;\n  box-shadow: 0 0 50px 50px #ffffff;\n  background: #ffffff;\n  padding: 15px;\n  max-width: 450px;\n}\n.adminDiffControlContainer {\n  padding: 10px 15px;\n}\n.adminDiffControlContainer .changedKey,\n.adminDiffControlContainer .deletedKey,\n.adminDiffControlContainer .addedKey {\n  color: white;\n}\n.adminDiffControlContainer .changedKey {\n  background: #2568db;\n}\n.adminDiffControlContainer .deletedKey {\n  background: #d70015;\n}\n.adminDiffControlContainer .addedKey {\n  background: #208337;\n}\n.changed,\n.deleted,\n.new {\n  border-style: dashed;\n  border-width: 2px;\n}\n.changed {\n  border-color: #2568db !important;\n}\n.deleted {\n  border-color: #d70015 !important;\n}\n.new {\n  border-color: #208337 !important;\n}\n.df-workflow-title {\n  display: block;\n  color: #687078;\n  font-size: 0.6em;\n}\n.df-form-title {\n  font-size: 26px;\n}\n.df-segment-title {\n  display: block;\n  margin-bottom: 7.5px;\n}\n.save-all-container {\n  position: sticky;\n  top: -10px;\n  margin-top: -40px;\n  margin-left: auto;\n  padding: 0 15px;\n  z-index: 10001;\n}\n.btn-outline-secondary:not(:hover):not(:focus) {\n  background-color: #ffffff;\n}\n.alert-issues {\n  background: #ffc107;\n  color: #000;\n  font-weight: 600;\n}\n","\n@import \"/lib/Colors.less\";\n.overlayContainer {\n    position: relative;\n    .overlay {\n        display: flex;\n        align-items: center;\n        margin: auto;\n        z-index: 3;\n        .overlayCenter {\n            text-align: center;\n            z-index: 5;\n            opacity: 1;\n            box-shadow: 0 0 50px 50px #ffffff;\n            background: #ffffff;\n            padding: 15px;\n            max-width: 450px;\n        }\n    }\n}\n@added: #208337;\n@changed: #2568db;\n@deleted: #d70015;\n.adminDiffControlContainer {\n    padding: 10px 15px;\n    .changedKey,\n    .deletedKey,\n    .addedKey {\n        color: white;\n    }\n    .changedKey {\n        background: @changed;\n    }\n    .deletedKey {\n        background: @deleted;\n    }\n    .addedKey {\n        background: @added;\n    }\n}\n\n.changed,\n.deleted,\n.new {\n    border-style: dashed;\n    border-width: 2px;\n}\n.changed {\n    border-color: @changed !important;\n}\n.deleted {\n    border-color: @deleted !important;\n}\n.new {\n    border-color: @added !important;\n}\n.df-workflow-title {\n    display: block;\n    color: #687078;\n    font-size: 0.6em;\n}\n.df-form-title {\n    font-size: 26px;\n}\n.df-segment-title {\n    display: block;\n    margin-bottom: 7.5px;\n}\n.save-all-container {\n    position: sticky;\n    top: -10px;\n    margin-top: -40px;\n    margin-left: auto;\n    padding: 0 15px;\n    z-index: 10001;\n}\n.btn-outline-secondary:not(:hover):not(:focus) {\n    background-color: #ffffff;\n}\n.alert-issues {\n    background: @warning;\n    color: #000;\n    font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
